module.exports = __webpack_public_path__ + "static/media/shape_bg.49d71d78.png";